import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IKeycloakAppProfile } from '@auth/models/IKeycloakAppProfile.model';
import { MenuModule, PipesModule } from 'pu-core-library';
import { TruncateTextePipe } from '@shared/pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  standalone: true,
    selector: 'app-mon-compte-form',
    templateUrl: './mon-compte-form.component.html',
    styleUrls: ['./mon-compte-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MenuModule, PipesModule, TruncateTextePipe, TranslatePipe, NgClass]
})
export class MonCompteFormComponent {
  @Input() user!: IKeycloakAppProfile | null;
  @Input() entite: any;
  @Input() isGroup!: boolean | null;
  @Input() isMonoSiret!: boolean | null;

  @Output() deconnect = new EventEmitter();

  onDeconnect() {
    this.deconnect.emit();
  }
}
